import { useEffect } from 'react';

/**
 * Custom hook to set the page title
 * @param {string} title - The page-specific title (e.g., "Dashboard")
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    const baseTitle = 'AV Factory EMP';
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    
    // Cleanup: reset to base title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [title]);
};

export default usePageTitle;
